module.exports = __webpack_public_path__ + "img/CosmEthically-ACTIVE-Journal2.8232d82a.png";